import React from "react";

export const IconUncompletedStep = ({ handleClick = false }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <circle cx="16" cy="16" r="16" fill="#F5F5F5" />
    <path
      d="M16.0065 22.128C18.7905 22.128 20.2945 19.84 20.2945 16.4C20.2945 12.96 18.7905 10.672 16.0065 10.672C13.1905 10.672 11.7185 12.96 11.7185 16.4C11.7185 19.84 13.1905 22.128 16.0065 22.128ZM13.2065 16.4C13.2065 13.712 14.1665 11.968 16.0065 11.968C17.8145 11.968 18.7905 13.712 18.7905 16.4C18.7905 19.088 17.8145 20.816 16.0065 20.816C14.1665 20.816 13.2065 19.088 13.2065 16.4Z"
      fill="#979797"
    />
  </svg>
);

export default IconUncompletedStep;
